module.exports = __webpack_public_path__ + "img/17-2.475118e0.png";